import { request } from '@/utils/request'
import qs from 'qs'

/**
 * @description 获取资讯类型列表
 */
export function getInformationTypsList() {
  return request({
    url: '/zhongcaijie/h5/information/getZcjInformationTyps',
    method: 'get',
  })
}

/**
 * @description 获取资讯，我关注的咨询文章列表
 */
export function getFollowInformationList(params: any) {
  return request({
    url: '/zhongcaijie/h5/information/getZcjH5FollowInformationList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取资讯，热榜文章列表
 */
export function getZcjH5InformationHotList(params: any) {
  return request({
    url: '/zhongcaijie/h5/information/getZcjH5InformationHotList',
    method: 'get',
    params,
  })
}

/**
 * @description 推荐,早报,创业,财税,法律 资讯列表
 */
export function getZcjH5InformationList(params: any) {
  return request({
    url: '/zhongcaijie/h5/information/getZcjH5InformationList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取资讯详情
 */
export function getZcjInformation(params: any) {
  return request({
    url: '/zhongcaijie/h5/information/getZcjInformation',
    method: 'get',
    params,
  })
}

/**
 * @description 获取话题列表
 */
export function getTopicList(params: any) {
  return request({
    url: '/zhongcaijie/h5/topic/getZcjTopicH5List',
    method: 'get',
    params,
  })
}

/**
 * @description 获取话题详情
 */
export function getTopicDetails(params: any) {
  return request({
    url: '/zhongcaijie/h5/topic/getZcjTopicDetails',
    method: 'get',
    params,
  })
}

/**
 * @description 获取前5条热门话题类型
 */
export function getTopicTypeList(params: any) {
  return request({
    url: '/zhongcaijie/h5/topic/getZcjTopicTypeH5List',
    method: 'get',
    params,
  })
}

/**
 * @description 收藏
 */
export function saveUserCollection(params: any) {
  return request({
    url: '/zhongcaijie/h5/collection/saveUserCollection',
    method: 'post',
    params,
  })
}

/**
 * @description 点赞
 */
export function saveZcjLike(params: any) {
  return request({
    url: '/zhongcaijie/h5/like/saveZcjLike',
    method: 'post',
    params,
  })
}

/**
 * @description 获取评论
 */
export function getZcjCommentList(params: any) {
  return request({
    url: '/zhongcaijie/h5/comment/getZcjCommentList',
    method: 'get',
    params,
  })
}

/**
 * @description 评论
 */
export function saveTbZcjComment(params: any) {
  return request({
    url: '/zhongcaijie/h5/comment/saveTbZcjComment',
    method: 'post',
    params,
  })
}

/**
 * @description 关注
 */
export function saveZcjUserFollow(params: any) {
  return request({
    url: '/zhongcaijie/h5/follow/saveZcjUserFollow',
    method: 'post',
    params,
  })
}

/**
 * @description 获取收藏资讯列表
 */
export function getInformationCollectionList(params: any) {
  return request({
    url: '/zhongcaijie/h5/information/getZcjH5InformationCollectionList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取收藏话题列表
 */
export function getTopicCollectionList(params: any) {
  return request({
    url: '/zhongcaijie/h5/topic/getZcjTopicH5CollectionList',
    method: 'get',
    params,
  })
}

/**
 * @description 获取收藏小视频列表
 */
export function getSmallVideoCollectionList(params: any) {
  return request({
    url: '/smallVideo/getZcjSmallVideoCollectionList',
    method: 'get',
    params,
  })
}

//
export function addUserIntegralShare(zcjUserId: string) {
  return request({
    url: `/zhongcaijie/h5/userSign/addUserIntegralShare?zcjUserId=${zcjUserId}`,
    method: 'post',
  })
}
